import type { TextResult } from '@core-api/presentation/types/response';
import { useFetchTextResults } from '@mentimeter/presentation-data-hooks/fetch-text-results';

interface UseTextResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useTextResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseTextResultsParams): {
  results: TextResult[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useFetchTextResults({
    adminKey,
    interactiveContentId,
    shouldFetchResults,
    sessionId,
  });

  return {
    results: data?.results ?? [],
    isLoading,
  };
};
